import React, { FunctionComponent } from "react";
import { FocusableHeader, StateSelector } from "../../components";
import { useQueryParams, useTranslate } from "../../helpers";
import { RouteComponentProps, withRouter } from "react-router";

const SpapLandingPage: FunctionComponent<RouteComponentProps> = ({
  location,
  history,
  match,
}) => {
  const t = useTranslate();
  useQueryParams({ location, history, match });

  return (
    <div className="SpapLandingPage">
      <div className="SpapLandingPage__hero">
        <div className="SpapLandingPage__heroContent">
          <FocusableHeader
            className="SpapLandingPage__heroHeader"
            text={t("spap.landing.header")}
            ignoreFocus={false}
          />
          <div className="SpapLandingPage__subheader mct-p1 ds-u-color--white ds-u-text-align--center ds-u-margin-top--2 ds-u-margin-bottom--7">
            {t("spap.landing.subheader")}
          </div>
        </div>
      </div>

      <div className="SpapLandingPage__content">
        <div className="SpapLandingPage__card">
          <StateSelector
            buttonText={t("spap.state_selector.button_text")}
            defaultLabel={t("spap.state_selector.select_state")}
            programType="SPAP"
          />
          <p>{t("spap.landing.state_disclaimer")}</p>
        </div>
      </div>
    </div>
  );
};

export default withRouter(SpapLandingPage);
